module.exports = __webpack_public_path__ + "img/paper-plus.381a16ce.svg";